import React from 'react';
import { YStack, YStackProps } from 'tamagui';

interface CobuContainerProps extends YStackProps {
  center?: boolean;
  centerHorizontal?: boolean;
  centerVertical?: boolean;
  safeArea?: boolean;
}

const CobuContainer: React.FC<CobuContainerProps> = ({
  center = false,
  centerHorizontal = false,
  centerVertical = false,
  safeArea = false,
  children,
  ...props
}) => {
  return (
    <YStack
      f={1}
      jc={center || centerVertical ? 'center' : undefined}
      ai={center || centerHorizontal ? 'center' : undefined}
      pt={safeArea ? '$12' : undefined}
      {...props}
    >
      {children}
    </YStack>
  );
};

export default CobuContainer; 